import * as React from 'react';
var KeepAliveContext = React.createContext({});
export default KeepAliveContext;
